import React from 'react';

/**
 * PART 3, раздел 7: показываем только те поля, для которых есть backend.
 * Редактируемых полей здесь нет — write-эндпоинта для профиля не существует,
 * а рисовать «работающую» форму без API ТЗ прямо запрещает.
 */
const ROLE_LABELS = {
  admin: 'Администратор',
  user: 'Пользователь',
};

const ProfileAccountTab = ({ user, loading, error }) => {
  if (loading) return <div className="pp-state">Загрузка…</div>;
  if (error) return <div className="pp-state pp-state--error">{error}</div>;

  return (
    <div className="pp-card">
      <h2 className="pp-card-title">Данные аккаунта</h2>

      <div className="pp-field">
        <span className="pp-field-label">Email</span>
        <span className="pp-field-value">{user?.email || '—'}</span>
      </div>

      <div className="pp-field">
        <span className="pp-field-label">Роль</span>
        <span className="pp-field-value">{ROLE_LABELS[user?.role] || user?.role || '—'}</span>
      </div>

      <div className="pp-field">
        <span className="pp-field-label">Статус аккаунта</span>
        <span className="pp-field-value">{user?.is_active === false ? 'Заблокирован' : 'Активен'}</span>
      </div>
    </div>
  );
};

export default ProfileAccountTab;
